module.exports = __webpack_public_path__ + "img/c0c755c4a2f783163a75b8189b5810ab45c7652e.e96fac97.gif";